import { useCallback, useRef } from 'react';
import { useState } from 'react';
import { safeParseJSONNotRef } from '../utils/jsonValidator';
import { resolveConfig } from '../helpers/configResolver';

export function useResolveBodyData(body_data) {
    const [bodyData, setbodyData] = useState(() => safeParseJSONNotRef(body_data));

    const initialRef = useRef(safeParseJSONNotRef(body_data));

    const resolveInfo = useCallback((data, key = null) => {
        const obj = resolveConfig(bodyData, data, {}, key);
        setbodyData(obj);
        return obj;
    }, [bodyData])

    const resetInit = useCallback(() => {
        setbodyData(safeParseJSONNotRef(initialRef.current));
    }, []);

    return { bodyData, resolveInfo, resetInit };
}
